export default __webpack_public_path__ + "static/media/Death-bloom Thorn Caster.ff208b3e.jpg";